import { Component, lazy, Suspense } from "react";
import { arrayOf, bool, func, shape, string } from "prop-types";

import { routes } from "../../constants";
import StylesNormalize from "../../styles/Styles.normalize";

import PageScrollRestoration from "./components/Page.scroll-restoration";
import { SearchProvider } from "../search/Search.context";

const ModalReauthorize = lazy(() => import("../modal-reauthorize"));
const ModalSignup = lazy(() => import("../modal-signup"));
const PageWrapper = {};

/**
 * Primary page wrapper
 * * Determines if mobile or desktop page wrapper should be displayed
 * * Updates page title after a route change
 */
class Page extends Component {
  constructor(props) {
    super(props);

    this.getPageWrapper = this.getPageWrapper.bind(this);
    this.getSettingsLinks = this.getSettingsLinks.bind(this);
  }

  componentDidMount() {
    const {
      targetDevice,
      locations,
      locationsError,
      locationsLoading,
      locationsFetch,
    } = this.props;

    if (targetDevice === "mobile") {
      if (
        (!locations || !locations.length) &&
        !locationsError &&
        !locationsLoading
      ) {
        locationsFetch();
      }
    }
  }

  /**
   * Get the correct page wrapper for the target device
   * * Uses code React.lazy for code splitting
   * @public
   */
  getPageWrapper() {
    const { getSettingsLinks, props } = this;
    const { targetDevice } = props;

    if (!!targetDevice) {
      if (!PageWrapper[targetDevice]) {
        PageWrapper[targetDevice] = lazy(
          () => import(`./components/Page.${targetDevice}`)
        );
      }

      const PageComponent = PageWrapper[targetDevice];
      const settingsLinks = getSettingsLinks();

      return <PageComponent {...props} settingsLinks={settingsLinks} />;
    } else {
      return null;
    }
  }

  /**
   * Get list of links for My Settings navigation
   * based on the user's role
   * @public
   */
  getSettingsLinks() {
    const { authenticated } = this.props;
    const { alerts, watch } = routes;
    const links = [watch];

    if (authenticated) {
      links.unshift(alerts);
    }

    return links;
  }

  render() {
    const { getPageWrapper } = this;
    const { authenticated, modalSignupShow, trackEvent, trackModalView } =
      this.props;

    return (
      <SearchProvider>
        <PageScrollRestoration />
        <Suspense fallback={null}>{getPageWrapper()}</Suspense>
        <Suspense fallback={null}>
          {authenticated && <ModalReauthorize />}
        </Suspense>
        <Suspense fallback={null}>
          {modalSignupShow && (
            <ModalSignup
              trackEvent={trackEvent}
              trackModalView={trackModalView}
            />
          )}
        </Suspense>
        <StylesNormalize />
      </SearchProvider>
    );
  }
}

Page.propTypes = {
  authenticated: bool,
  hasCompared: bool,
  logout: func.isRequired,
  user: shape({
    email: string,
    name: string,
    role: string,
  }),
  targetDevice: string,
  trackEvent: func,
  trackModalView: func,
  locations: arrayOf(
    shape({
      locationCity: string,
      slug: string,
    })
  ),
  locationsError: string,
  locationsFetch: func.isRequired,
  locationsLoading: bool,
  modalSignupShow: bool,
  signupFooterShow: bool,
};

Page.defaultProps = {
  authenticated: false,
  hasCompared: false,
};

export default Page;
